import { DiscountType } from '../api/discount/discount.types';
import { DiscountDownload } from './DiscountDownload';
import { DiscountUpload } from './DiscountUpload';

const getPanelTitle = (discountType: DiscountType) => {
    switch (discountType) {
        case DiscountType.ACCOUNT:
            return 'Account Discounts';
        case DiscountType.PRODUCT:
            return 'Product Discounts';
        default:
            return 'Asset Discounts';
    }
};

const getPanelIcon = (discountType: DiscountType) => {
    let iconClass: string;

    switch (discountType) {
        case DiscountType.ACCOUNT:
            iconClass = 'icon-user';
            break;
        case DiscountType.PRODUCT:
            iconClass = 'icon-parcel';
            break;
        default:
            iconClass = 'icon-truck-baseline';
    }

    return <span className={`uikit-icon ${iconClass} text-size-20 margin-right-10`} />;
};

export function DiscountPanel(props: { panelType: DiscountType }) {
    const { panelType } = props;
    const panelTitle = getPanelTitle(panelType);
    const panelIcon = getPanelIcon(panelType);

    return (
        <div className='panel panel-primary'>
            <div className='panel-heading'>
                {panelIcon}
                {panelTitle}
            </div>
            <div className='panel-body display-flex'>
                <div className='margin-right-10'>
                    <DiscountUpload discountType={panelType} />
                </div>
                <div>
                    <DiscountDownload discountType={panelType} />
                </div>
            </div>
        </div>
    );
}
